module.exports = __webpack_public_path__ + "static/media/testimonio3.5761c38b.jpg";